import React from 'react';

export type MentionNodeComponentContextValue = {
	respondedAgentId: string;
	disabledTooltip: string;
};

export const MentionNodeComponentContext: React.Context<
	MentionNodeComponentContextValue | undefined
> = React.createContext<MentionNodeComponentContextValue | undefined>(undefined);
